import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class Form extends PureComponent {
    render() {
        const {
            children,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            ['form']: true
        });

        return (
            <form className={classNames} {...props}>
                {children}
            </form>
        );
    }
}

Form.defaultProps = {};

export default Form;
